<div class="mr-20" fxFlex.gt-sm="50" id="emp-selection-consentimiento" *ngIf="selectionService.selectionPermissions.HasConsentimento">
    <mat-form-field floatLabel="never">
      <mat-label>Consentimiento</mat-label>
      <mat-select class="full-width-multi-select" [formControl]="filterService.Consentimientos" multiple (ngModelChange)="setConsentimento()">
        <mat-option *ngFor="let consentimiento of consentimientosOptions" [value]="consentimiento.value">{{consentimiento.text}}</mat-option>
      </mat-select>
    </mat-form-field>
</div>